import Service, { service } from '@ember/service';
import { trackedTask } from 'reactiveweb/ember-concurrency';
import { tracked } from '@glimmer/tracking';
import branchSettingsQuery from 'my-phorest/gql/queries/branch-settings.graphql';
import { keepLatestTask } from 'ember-concurrency';
import { action } from '@ember/object';
import { isDarkColor } from 'my-phorest/helpers/is-dark-color';
import { queryManager } from 'ember-apollo-client';

export default class BranchSettingsService extends Service {
  @service session;

  @queryManager apollo;

  @tracked previewBrandSrc;
  @tracked previewThemeSrc;

  branchSettings = trackedTask(this, this.fetchBranchSettingsTask, () => [
    this.previewBrandSrc,
    this.previewThemeSrc,
    this.session.branchId,
  ]);

  get appColor() {
    return (
      this.branchSettings.value?.brandThemeColour ??
      'linear-gradient(90deg,rgba(0, 160, 110, 1) 0%, rgba(13, 97, 93, 1) 32%, rgba(255, 174, 51, 1) 71%, rgba(255, 128, 128, 1) 100%)'
    );
  }

  get cacheBuster() {
    return new Date().getTime();
  }

  get brandThemeLogo() {
    let logoSrc = this.branchSettings.value?.brandThemeLogoUrl;

    if (logoSrc) {
      logoSrc += `?${this.cacheBuster}`;
    }

    return logoSrc ?? null;
  }

  get isThemeColorDark() {
    return this.branchSettings.value?.brandThemeColour
      ? isDarkColor(
          this.stripAlphaChannel(this.branchSettings.value?.brandThemeColour)
        )
      : true;
  }

  get isLoadingBranchSettings() {
    return !this.branchSettings.value && this.fetchBranchSettingsTask.isRunning;
  }

  get directTippingWithManualTips() {
    return this.branchSettings.value?.directTippingWithManualTips;
  }

  get paymentLinksEnabled() {
    return this.branchSettings.value?.payment.paymentLinksEnabled;
  }

  @action
  stripAlphaChannel(hex) {
    return hex.slice(0, -2);
  }

  @keepLatestTask
  *fetchBranchSettingsTask() {
    if (!this.session.branchId) return;

    return yield this.apollo.watchQuery(
      {
        query: branchSettingsQuery,
        variables: {
          branchId: this.session.branchId,
        },
        fetchPolicy: 'network-only',
      },
      'branch'
    );
  }
}
